<template>
    <div>



        <div style="width: 2040px;overflow-x: auto">

            <div class="container-fluid">

                <CRow class="mb-2 mt-0 pt-0">
                    <CCol md="12" class="mt-0 pt-0" >
                        <b-button size="sm" v-if="issueMoreDetailShow" @click="issueMoreDetailShow = false">نمایش کمتر</b-button>
                        <b-button size="sm"  v-if="!issueMoreDetailShow" @click="issueMoreDetailShow = true">نمایش بیشتر</b-button>

                        <b-button variant="default" size="sm"   @click="showFilter = !showFilter">نمایش فیلتر</b-button>
                    </CCol>
                </CRow>



                <div class="row flex-row flex-nowrap" >



                    <CCol v-if="showFilter" md="2">

                        <CCard class="p-4">

                            <div class="message-show text-right pt-3" >




                                <div
                                        style="cursor: pointer" >
                                    <div class="text-right margin-10 d-flex">
                                        <!--                                        tagSearc
                                                        var url = '/home/file/fileSearch/?input='+app.tagSearch
                                        h-->

                                        <div class="row text-right ">

<!--                                            <div class="col-6 my-2">-->
<!--                                                <small> از تاریخ ثبت:</small>-->
<!--                                                <custom-time-picker-->
<!--                                                        v-model="search.created_at_from" @change="getIssues()"-->
<!--                                                        type="date" :clearable="true" placeholder="" min="" max=""-->
<!--                                                        size="sm" input-class="form-control form-control-sm">-->
<!--                                                </custom-time-picker>-->
<!--                                            </div>-->

<!--                                            <div class="col-6 my-2">-->
<!--                                                <small> تا تاریخ ثبت:</small>-->
<!--                                                <custom-time-picker-->
<!--                                                        v-model="search.created_at_to" @change="getIssues()"-->
<!--                                                        type="date" :clearable="true" placeholder="" min="" max=""-->
<!--                                                        size="sm" input-class="form-control form-control-sm">-->
<!--                                                </custom-time-picker>-->
<!--                                            </div>-->


<!--                                            <div class="col-6 my-2">-->
<!--                                                <small> از تاریخ انجام:</small>-->
<!--                                                <custom-time-picker-->
<!--                                                        v-model="search.done_date_from" @change="getIssues()"-->
<!--                                                        type="date" :clearable="true" placeholder="" min="" max=""-->
<!--                                                        size="sm" input-class="form-control form-control-sm">-->
<!--                                                </custom-time-picker>-->
<!--                                            </div>-->

<!--                                            <div class="col-6 my-2">-->
<!--                                                <small> تا تاریخ انجام:</small>-->
<!--                                                <custom-time-picker-->
<!--                                                        v-model="search.done_date_to" @change="getIssues()"-->
<!--                                                        type="date" :clearable="true" placeholder="" min="" max=""-->
<!--                                                        size="sm" input-class="form-control form-control-sm">-->
<!--                                                </custom-time-picker>-->
<!--                                            </div>-->


                                            <!--                                  <div class="col-12">-->
                                            <!--                                      <label> برچسب:</label>-->

                                            <!--&lt;!&ndash;                                      <b-form-input&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                              v-model="tagSearch"&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                              type="text"&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                              @keyup="getIssues()"&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                              size="sm"&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                              placeholder="برچسب (تگ)"&ndash;&gt;-->
                                            <!--&lt;!&ndash;                                      ></b-form-input>&ndash;&gt;-->

                                            <!--                                  </div>-->




<!--                                            <div class="col-12 my-2">-->
<!--                                                <small> موضوع:</small>-->
<!--                                                <b-form-input v-model="search.title"-->
<!--                                                              @keyup="getIssues()"-->
<!--                                                              size="sm"-->
<!--                                                              type="text"-->
<!--                                                              placeholder="">-->
<!--                                                </b-form-input>-->
<!--                                            </div>-->




                                            <div class="col-12 my-2">
                                                <small>  نوع:</small>
                                                <b-form-select  size="sm" style="direction: ltr"
                                                                @change="getIssues()"
                                                                v-model="search.type"
                                                                type="text">
                                                    <b-form-select-option  value="">
                                                        همه
                                                    </b-form-select-option>


                                                    <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                           :value="type.id"  >
                                                        {{type.title}}
                                                    </b-form-select-option>
                                                    <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>

                                                </b-form-select>
                                            </div>



<!--                                            <div class="col-12 my-2">-->
<!--                                                <small>  وضعیت انجام:</small>-->
<!--                                                <b-form-select  size="sm" style="direction: ltr"-->
<!--                                                                @change="getIssues()"-->
<!--                                                                v-model="search.board_id"-->
<!--                                                                type="text">-->
<!--                                                    <b-form-select-option  value="">همه</b-form-select-option>-->
<!--                                                    <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>-->
<!--                                                    <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>-->
<!--                                                    <b-form-select-option  value="3"  style="color: #aeb130">درحال انجام (Doing)</b-form-select-option>-->
<!--                                                    <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
<!--                                                    <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>-->
<!--                                                </b-form-select>-->
<!--                                            </div>-->

                                            <div class="col-12 my-2">
                                                <small>  اولویت:</small>
                                                <b-form-select  size="sm" style="direction: ltr"
                                                                @change="getIssues()"
                                                                v-model="search.priority"
                                                                type="text">
                                                    <b-form-select-option  value="">همه</b-form-select-option>
                                                    <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                                    <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                                    <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                                </b-form-select>
                                            </div>


<!--                                            <div class="col-12 my-2">-->
<!--                                                <small> فرایند:</small>-->
<!--                                                <b-form-select  size="sm" style="direction: ltr"-->
<!--                                                                v-model="search.process_id" @change="getIssues()"-->
<!--                                                >-->
<!--                                                    &lt;!&ndash;                                          getSteps($event) &&&ndash;&gt;-->
<!--                                                    <b-form-select-option  value="">-->
<!--                                                        همه-->
<!--                                                    </b-form-select-option>-->
<!--                                                    <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"-->
<!--                                                                           :value="process.id"  >-->
<!--                                                        {{process.title}}-->
<!--                                                    </b-form-select-option>-->

<!--                                                </b-form-select>-->
<!--                                            </div>-->

<!--                                            <div class="col-12 my-2">-->
<!--                                                <small> مرحله:</small>-->
<!--                                                <b-form-select  size="sm" style="direction: ltr"-->
<!--                                                                v-model="search.step_id" @change="getIssues()"-->
<!--                                                >-->
<!--                                                    <b-form-select-option  value="">-->
<!--                                                        همه-->
<!--                                                    </b-form-select-option>-->
<!--                                                    <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >-->
<!--                                                        {{step.title}}-->
<!--                                                    </b-form-select-option>-->



<!--                                                </b-form-select>-->
<!--                                            </div>-->







<!--                                            <div class="col-12 my-2">-->
<!--                                                <small> مشتری:</small>-->
<!--                                                <v-select @change="getIssues()"-->
<!--                                                          v-model="search.contact_id"-->
<!--                                                          :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">-->
<!--                                                </v-select>-->


<!--                                                &lt;!&ndash;                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"&ndash;&gt;-->
<!--                                                &lt;!&ndash;                                         placeholder=" انتخاب مشتری" label="title" track-by="title">&ndash;&gt;-->
<!--                                                &lt;!&ndash;                            </multiselect>&ndash;&gt;-->
<!--                                            </div>-->

                                            <div class="col-12 my-2">
                                                <small>پروژه:</small>

                                                <v-select @change="getIssues()"
                                                          v-model="search.project_id"
                                                          :options="projects" label="title" :reduce="project => project.id" value="id">
                                                </v-select>

                                            </div>





                                            <!--                                  <div class="col-12 my-2">-->
                                            <!--                                      <small> {{$client}}:</small>-->
                                            <!--                                      <b-form-select  size="sm" style="direction: ltr"-->
                                            <!--                                                      v-model="search.contact_id" @change="getIssues()"-->
                                            <!--                                      >-->
                                            <!--                                          <b-form-select-option  value="">-->
                                            <!--                                              همه-->
                                            <!--                                          </b-form-select-option>-->

                                            <!--                                          <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"   :value="contact.id" >-->
                                            <!--                                              {{contact.last_name}}-->
                                            <!--                                          </b-form-select-option>-->


                                            <!--                                      </b-form-select>-->
                                            <!--                                  </div>-->

                                            <!--                                  <div class="col-12 my-2">-->
                                            <!--                                      <small> پروژه:</small>-->
                                            <!--                                      <b-form-select  size="sm" style="direction: ltr"-->
                                            <!--                                      >-->
                                            <!--                                          <b-form-select-option  value="">-->
                                            <!--                                              همه-->
                                            <!--                                          </b-form-select-option>-->


                                            <!--                                      </b-form-select>-->
                                            <!--                                  </div>-->
                                            <div class="col-12 mt-3">
                                                <button @click="getIssues()" class="btn btn-success">فیلتر</button>
                                            </div>


                                        </div>




                                        <!--                                  <multiselect  v-model="newPost.fileLib_tags" :height="300" :options="options" :multiple="true"-->
                                        <!--                                                                  :taggable="true" :close-on-select="false" :clear-on-select="false"-->
                                        <!--                                                                  :custom-label="customLabel"-->
                                        <!--                                                                  :preserve-search="true" :hide-selected="true" :show-labels="false"-->
                                        <!--                                                                  tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"-->
                                        <!--                                                                  label="title" track-by="title" :preselect-first="false"-->

                                        <!--                                                                  @tag="addTag">-->
                                        <!--                                                        &lt;!&ndash; <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"-->
                                        <!--                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> &ndash;&gt;-->
                                        <!--                                        </multiselect>-->
                                    </div>
                                </div>







                            </div>

                        </CCard>
                    </CCol>




                    <b-col  v-for="(board, boardsWithIssueIndex) in boardsWithIssues" :key="boardsWithIssueIndex" style="max-width: 500px;min-width: 200px">

                        <CWidgetDropdown  :style="{backgroundColor: styleColor(board.id)}"  :header="board.title" text="مرحله ">
                            <template #default>
                                <CDropdown
                                        color="transparent p-0"
                                        placement="bottom-end"
                                        :caret="false"
                                >
                                    <template #toggler-content>
                                        <CIcon name="cil-task"/>
                                    </template>
                                    <CDropdownItem v-b-modal.modal-add-course variant="primary"
                                    >
                                        افزودن issue</CDropdownItem>
                                </CDropdown>
                            </template>

                        </CWidgetDropdown>


                        <table  class="table table-hover table-fit">

                        <draggable class="list-group" tag="ul" v-model="board.issues"  v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false" @change="issueMoved(board.id, board.title, $event)" >



                            <li  v-for="(issue, issueIndex) in board.issues" :key="issueIndex"
                                 style="width: 100%!important;border-top: 2px solid #9e9e9e;background-color: #fafafa;border-radius: 6px;
                                       overflow-x: hidden;margin-bottom: 15px;box-shadow: 0 0 3px rgba(0,0,0,.04)">

                                <issueList  :issue="issue" :issueMoreDetailShow="issueMoreDetailShow">
                            </issueList>

                            </li>



                        </draggable>

                        </table>


                    </b-col>











                </div>
            </div>



        </div>










        <b-modal id="modal-add-course" size="lg" title="افزودن پست " ok-only ok-variant="secondary" ok-title="Cancel">

            <addIssue  :parent_id="addIssue.parent_id"
                       :reply_id="addIssue.reply_id"
                       :section_id="addIssue.section_id">
            </addIssue>


        </b-modal>





    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import MainChartExample from './charts/MainChartExample'
    import WidgetsDropdown from './widgets/WidgetsDropdown'
    import WidgetsBrand from './widgets/WidgetsBrand'

    import { CChartLineSimple, CChartBarSimple } from './charts/index'

    import Multiselect from 'vue-multiselect'

    import draggable from "vuedraggable";
    import addIssue from './issue/add'
    import issueList from "./issue/list";


    export default {
        name: 'Dashboard',
        components: {
            MainChartExample,
            WidgetsDropdown,
            WidgetsBrand,
            CChartLineSimple,
            CChartBarSimple,

            Multiselect,
            draggable,

            addIssue,
            issueList,




        },
        data () {
            return {


                list: [
                    {
                        "name": "vue.js 2.0",
                        "order": 5,
                        "fixed": false
                    },
                    {
                        "name": "Sortablejs",
                        "order": 8,
                        "fixed": false
                    },
                    {
                        "name": "for",
                        "order": 4,
                        "fixed": false
                    },
                    {
                        "name": "based",
                        "order": 6,
                        "fixed": false
                    }
                ],

                list2: [
                    {
                        "name": "component",
                        "order": 3,
                        "fixed": false
                    },
                    {
                        "name": "on",
                        "order": 7,
                        "fixed": false
                    },
                    {
                        "name": "draggable",
                        "order": 2,
                        "fixed": false
                    },
                    {
                        "name": "vue.draggable",
                        "order": 1,
                        "fixed": false
                    }
                ],


                editable: true,
                isDragging: false,
                delayedDragging: false,


                selected: 'Month',
                tableItems: [
                    {
                        avatar: { url: 'img/avatars/1.jpg', status: 'success' },
                        user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'USA', flag: 'cif-us' },
                        usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
                        activity: '10 sec ago'
                    },
                    {
                        avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
                        user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
                        country: { name: 'Brazil', flag: 'cif-br' },
                        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Visa', icon: 'cib-cc-visa' },
                        activity: '5 minutes ago'
                    },
                    {
                        avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
                        user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'India', flag: 'cif-in' },
                        usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Stripe', icon: 'cib-stripe' },
                        activity: '1 hour ago'
                    },
                    {
                        avatar: { url: 'img/avatars/4.jpg', status: '' },
                        user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'France', flag: 'cif-fr' },
                        usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'PayPal', icon: 'cib-paypal' },
                        activity: 'Last month'
                    },
                    {
                        avatar: { url: 'img/avatars/5.jpg', status: 'success' },
                        user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'Spain', flag: 'cif-es' },
                        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
                        activity: 'Last week'
                    },
                    {
                        avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
                        user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'Poland', flag: 'cif-pl' },
                        usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Amex', icon: 'cib-cc-amex' },
                        activity: 'Last week'
                    }
                ],
                tableFields: [
                    { key: 'avatar', label: '', _classes: 'text-center' },
                    { key: 'user' },
                    { key: 'country', _classes: 'text-center' },
                    { key: 'usage' },
                    { key: 'payment', label: 'Payment method', _classes: 'text-center' },
                    { key: 'activity' },
                ],





                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                loadMore: true,
                page: 0,
                pageSize: 10,
                voice: '',

                courseCategories:[],
                fileCategories:[],
                forumCategories:[],
                forums:[],


                issues:[],
                issues1:[],
                issues2:[],
                issueText: 0,
                newIssue: {
                    intro:'',
                    state:'0',
                    title:'',
                    text:'0',

                    voice:'',
                    file:'',
                    image:'',
                    video:'',

                    news:0,
                    course_id:null,
                    course_category_id:null,
                    forum_id:null,
                    forum_category_id:null,
                    fileLib_tags:null,
                    // issue_likes:null,
                    // userLike:null,

                    type:'ticket',
                    project_id:null,
                    board_id:2,
                    users:[],

                    priority:2,
                    due_date:null,
                    tags:[],

                },

                rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

                showVoiceRecorder: false,
                showFileUploader: false,
                showImageUploader: false,
                showVideoUploader: false,

                src: null,
                srcPlay: null,

                issueAsCourse: false,
                issueAsForum: false,

                courseDisabled: false,
                forumDisabled: false,

                newComment:'',
                newReply:'',

                options:[],

                selectedTags: [],
                tags: [],
                isLoading: false,




                typeOptions: [
                    { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
                    { value: 'bug', text: 'ایراد (Bug)' },
                    { value: 'task', text: 'فعالیت (Task)' },
                    { value: 'user-story', text: 'لیست (User Story)' },
                    { value: 'epic', text: 'نسخه/فیچر (Epic)' },
                    { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
                    { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

                ],



                warningModal: false,


                boardsWithIssues: [],
                steps: [],



                addIssue: {
                    parent_id: null,
                    reply_id: null,
                    sprint_id: null,
                    board_id: null,
                    process_id: null,
                    section_id: null,
                    step_id: null
                },

                issueMoreDetailShow:true,


                search: {

                    title: '',
                    description: '',
                    type: '',
                    project_id: '',
                    section_id: '',
                    process_id: '',
                    step_id: '',
                    board_id: '',

                    created_at_from: '',
                    created_at_to: '',
                    due_date: '',
                    start_date: '',
                    done_date_from: '',
                    done_date_to: '',
                    close_date: '',

                    priority: '',
                    contact_id: '',
                    order_id: '',
                    person_id: '',
                    created_by: '',
                    updated_by: '',
                },

                showFilter:false,

                processes: [],
                orders: [],
                contacts: [],
                projects: [],

                types: [],

            }
        },




        mounted() {

            // this.getSteps()
            this.getIssues()
            // this.getFileCategories()
            // this.getForumCategories()
            // this.getForums()


            this.getProjects()


        },



        methods: {

            onMove({ relatedContext, draggedContext }) {
                const relatedElement = relatedContext.element;
                const draggedElement = draggedContext.element;
                if (this.isDragging==false)
                console.log('draggedContext', draggedContext,'relatedContext',relatedContext )
                return (
                    (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                );
            },

            issueMoved(boardID, boardTitle , dragged){
                this.isDragging = false
                console.log(boardID, boardTitle ,'dragged', dragged)

                if(dragged.added){
                    console.log(boardID, dragged.added.element)
                    this.updateIssue(dragged.added.element.id, dragged.added.element.title, dragged.added.element.state, boardID, dragged.added.element.step_id)
                }


            },





            updateIssue(id, title, state, boardId, stepId){
                var app = this;

                var params= {
                    // title: title,
                    // state: state,
                    board_id: boardId,
                    // step_id: stepId
                }

                axios.post(`/api/issue/edit/`+id,  params , app.auth)
                    .then(function (resp) {
                        console.log(resp,"")
                        // app.items.push(app.timing);
                        app.$snotify.success(' با موفقیت ویرایش شد');

                        app.getIssues()
                    })
                    .catch(
                        e => {
                            console.log(e);
                            app.$snotify.error('امکان ویرایش وجود ندارد');
                        }
                    );

            },


            color (value) {
                let $color
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },

            getIssues(){
                var app = this;
                // axios.get('/api/intro/getBoardsWithIssues', app.auth)
                axios.get('/api/intro/getBoardsWithIssues' +
                    '?title='+app.search.title+
                    '&description='+app.search.description+
                    '&type='+app.search.type+
                    '&project_id='+app.search.project_id+
                    '&section_id='+app.search.section_id+

                    '&process_id='+app.search.process_id+
                    '&step_id='+app.search.step_id+
                    '&board_id='+app.search.board_id+

                    '&created_at_from='+app.search.created_at_from+
                    '&created_at='+app.search.created_at_to+
                    '&created_at_to='+app.search.due_date+
                    '&start_date='+app.search.start_date+
                    '&done_date_from='+app.search.done_date_from+
                    '&done_date_to='+app.search.done_date_to+
                    '&close_date='+app.search.close_date+

                    '&priority='+app.search.priority+
                    '&contact_id='+app.search.contact_id+
                    '&order_id='+app.search.order_id+
                    '&person_id='+app.search.person_id+
                    '&created_by='+app.search.created_by+
                    '&updated_by='+app.search.updated_by
                    , app.auth)
                    .then(function (response) {
                        app.boardsWithIssues = response.data.data.data

                        console.log('boardsWithIssues',response.data.data.data);
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            // getIssues(){
            //     var app = this;
            //     axios.get('/api/intro/index', app.auth)
            //         .then(function (response) {
            //             app.issues = response.data.data
            //             app.issues1 = response.data.data
            //             app.issues2 = response.data.data
            //             // console.log(response.data);
            //         })
            //         .catch(function (e) {
            //             console.log(e.response);
            //         });
            // },

            getMoreIssues(){
                var app = this;



                if(app.loadMore == true){

                    axios.get('/api/intro/index?page='+app.page, app.auth)
                        .then(res => {
                            // app.issues.concat(res.data.data)
                            res.data.data.forEach(
                                (val)=>{ app.issues.push(val)});

                            app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                            // Stop scroll-loader
                            res.data.data.length < app.pageSize && (app.loadMore = false)
                        })
                        .catch(error => {
                            console.log(error);
                        })

                }


            },


            getSteps(processID = null){
                var app = this;
                axios.get('/api/intro/steps/'+processID ,  app.auth)
                    .then(function (response) {
                        app.steps = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight
                const bottomOfPage = visible + scrollY >= pageHeight
                return bottomOfPage || pageHeight < visible
            },

            // onFileChangeImage(e) {
            //     this.newIssue.image = this.$refs.file.files[0];
            //     this.placeholder = this.$refs.file.files[0].name+'333'
            //     console.log(this.newIssue ,"test Issue image")
            // },
            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },

            //            openChat() {
            //                if (document.getElementById("box-chat").style.height == "400px") {
            //                    document.getElementById("box-chat").style.height = "60px"
            //                    document.getElementById("div-message-chat").style.display = "none"
            //                } else {
            //                    document.getElementById("box-chat").style.height = "400px"
            //                    document.getElementById("div-message-chat").style.display = "block"
            //                }
            //
            //
            //            },

            showIssueText(text, index ){

                this.issues[index].intro = text

            },

            onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
                this.srcPlay =  window.URL.createObjectURL(data)
                this.src =  data

            },

            headerStyles(issueType){
                if (issueType.type == 1)
                    return '2px solid #880e4e'
                else if (issueType.type == 2)
                    return '2px solid #f50057'
                else if (issueType.type == 3)
                    return '2px solid #8e24aa'
                else if (issueType.type == 4)
                    return '2px solid #263238'
                else if (issueType.type == 5)
                    return '2px solid #dd2c00'
                else if (issueType.type == 6)
                    return '2px solid #00c853'
                else if (issueType.type == 7)
                    return '2px solid #0097a7'
                else if (issueType.type == 8)
                    return '2px solid #0288d1'
                else if (issueType.type == 9)
                    return '2px solid #0208ff'
                else if (issueType.type == 10)
                    return '2px solid #eeb600'
                else if (issueType.type == 10)
                    return '2px solid #0e8e2e'
                else if (issueType.type == 11)
                    return '2px solid #888'
                else
                    return '2px solid #888888'
            },



            boardColor(boardID){
                if (boardID == 1)
                    return '#ee6600'
                else if (boardID == 2)
                    return '#ffd600'
                else if (boardID == 3)
                    return '#aeb130'
                else if (boardID == 4)
                    return '#64dd17'
                else if (boardID == 5)
                    return '#0097a7'
                else if (boardID == 6)
                    return '#00bfa5'
                else
                    return ''
            },

            typeBadgeStyles(issueType){
                if (issueType.type == 1)
                    return '#880e4e'
                else if (issueType.type == 2)
                    return '#f50057'
                else if (issueType.type == 3)
                    return '#8e24aa'
                else if (issueType.type == 4)
                    return '#263238'
                else if (issueType.type == 5)
                    return '#dd2c00'
                else if (issueType.type == 6)
                    return '#00c853'
                else if (issueType.type == 7)
                    return '#0097a7'
                else if (issueType.type == 8)
                    return '#0288d1'
                else if (issueType.type == 9)
                    return '#0208ff'
                else if (issueType.type == 10)
                    return '#eeb600'
                else if (issueType.type == 10)
                    return '#0e8e2e'
                else if (issueType.type == 11)
                    return '#888'
                else
                    return '#888888'
            },







            issueTypeText(issueType) {
                if (issueType.type == 1)
                    return 'سرنخ (Lead)'
                else if (issueType.type == 2)
                    return 'فرصت (Opportunity)'
                else if (issueType.type == 3)
                    return 'ملاقات/جلسه/رویداد'
                else if (issueType.type == 4)
                    return 'پیگیری (Ticket)'
                else if (issueType.type == 5)
                    return 'ایراد (Bug)'
                else if (issueType.type == 6)
                    return 'فعالیت (Task)'
                else if (issueType.type == 7)
                    return 'لیست/شرح (Story)'
                else if (issueType.type == 8)
                    return 'مجموعه/امکانات (Epic)'
                else if (issueType.type == 9)
                    return 'پیام/تلفن (Message)'
                else if (issueType.type == 10)
                    return 'گزارش/خبر (Report)'
                else if (issueType.type == 11)
                    return 'سایر'
                else
                    return 'سایر'
            },



            getCourseCategories(){
                var app = this;
                axios.get('/api/admin/list/5', app.auth)
                    .then(function (response) {
                        app.courseCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getFileCategories(){
                var app = this;
                axios.get('/api/file/tagSearch/', app.auth)
                    .then(function (response) {
                        app.fileCategories = response.data.data.tags.data

                        console.log(response.data.data.tags.data)


                        for (const key in app.fileCategories) {
                            if (app.fileCategories.hasOwnProperty(key)) {
                                const element = app.fileCategories[key];

                                app.options.push({
                                    title: '#'+element.title,
                                    id: element.id
                                })
                                // this.details[0].
                            }
                        }
                        console.log(app.options)


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForumCategories(){
                var app = this;
                axios.get('/api/admin/list/2', app.auth)
                    .then(function (response) {
                        app.forumCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForums(){
                var app = this;
                axios.get('/api/forum/best', app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            updateForums(event){
                var categoryID = event;
                var app = this;
                axios.get('/api/forum/list?cat_id='+categoryID, app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            likeIssue(issue){
                var app = this;
                axios.get('/api/issue/like/'+issue.id, app.auth)
                    .then(function (response) {

                        console.log(app.issues.find(x => x.id == issue.id).user_like)

                        if (app.issues.find(x => x.id == issue.id).user_like.length == 0) {
                            app.$snotify.success('پسند شما برای این پست (Issue) ثبت شد');
                            $("#like-far-"+issue.id).attr("data-prefix","fas");
                            $("#like-fas-"+issue.id).attr("data-prefix","fas");
                            // $("#like-far-"+issue.id).removeClass("fas").addClass("far");
                            app.issues.find(x => x.id == issue.id).like ++
                            app.issues.find(x => x.id == issue.id).user_like.push({
                                types_id: 1,
                                users_id: 0,
                                targets_id: issue.id})
                        }
                        else{
                            app.$snotify.info('پسند شما برای این پست (Issue) لغو شد');
                            $("#like-fas-"+issue.id).attr("data-prefix","far");
                            $("#like-far-"+issue.id).attr("data-prefix","far");
                            // $("#like-fas-"+post.id).removeClass("far").addClass("fas");
                            app.issues.find(x => x.id == issue.id).like --
                            app.issues.find(x => x.id == issue.id).user_like = []
                        }


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getUserLikes(issue){
                var app = this;
                axios.get('/api/intro/likes/'+issue.id, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issue.id).issue_likes = response.data

                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            sendComment(issueId){
                var app = this;
                var newItem = {
                    parent_id: 0,
                    issue_id: issueId,
                    comment: document.getElementById('newComment-'+issueId).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('نظر با موفقیت ثبت شد');
                        document.getElementById('newComment-'+issueId).value = ''
                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت نظر وجود ندارد');
                        }
                    );

            },

            showReplyForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).show();
            },

            sendReply(issueId, commentID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issu_id: postId,
                    comment: document.getElementById('reply-'+issueId+'-'+commentID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+commentID).hide();
                        document.getElementById('reply-'+issueId+'-'+commentID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },

            sendReplyOfReply(issueId, commentID, replyID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issue_id: issueId,
                    comment: document.getElementById('reply-'+issueId+'-'+replyID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+replyID).hide();
                        document.getElementById('reply-'+issueId+'-'+replyID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },

            hideForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).hide();
            },

            updateIssueComments(issueId){

                var app = this;
                axios.get('/api/intro/getComments/'+issueId+'/'+null, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issueId).comments = response.data.data.data

                        console.log(app.issues.find(x => x.id == issueId).comments)
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });

            },

            getMoreComments(issueId){

                var app = this;
                if (!app.issues.find(x => x.id == issueId).commentPage)
                    app.issues.find(x => x.id == issueId).commentPage =2

                axios.get('/api/intro/getComments/'+issueId+'/'+null+'?page='+app.issues.find(x => x.id == issueId).commentPage, app.auth)
                    .then(res => {
                        res.data.data.data.forEach(
                            (val)=>{ app.issues.find(x => x.id == issueId).comments.push(val)});

                        if (res.data.data.data.length != 0)
                            app.issues.find(x => x.id == issueId).commentPage = res.data.data.current_page+1


                    })
                    .catch(error => {
                        console.log(error);
                    })



            },

            customLabel(option) {
                //   console.log(option.title)

                //   this.item.tags.push(option)
                return `${option.title}`

            },

            addTag (newTag) {
                // const tag = {
                //     name: newTag,
                //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                // }
                // this.options.push(tag)
                // this.value.push(tag)

                this.options.push({
                    title: '#'+newTag,
                    id: 0
                })
            },

            ajaxFindTag(query){

            },

            limitText (count) {
                return `and ${count} other tags`
            },

            asyncFind (query) {
                this.isLoading = true
                this.ajaxFindTag(query).then(response => {
                    this.tags = response
                    this.isLoading = false
                })
            },

            clearAll () {
                this.selectedTags = []
            },


            bootstrapColor(key){
                if (key ==0)
                    return 'info'
                if (key ==1)
                    return 'danger'
                if (key ==2)
                    return 'warning'
                if (key ==3)
                    return 'success'
                if (key ==4)
                    return 'secondary'
                else
                    return 'primary'
            },



            styleColor(boardID){
                if (boardID == 1)
                    return '#ee6600'
                else if (boardID == 2)
                    return '#ffd600'
                else if (boardID == 3)
                    return '#aeb130'
                else if (boardID == 4)
                    return '#64dd17'
                else if (boardID == 5)
                    return '#0097a7'
                else if (boardID == 6)
                    return '#00bfa5'
                else
                    return ''
            },



            getProjects() {
                axios
                    .get('/api/projectList', this.auth)
                    .then(response => {

                        this.projects = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
            },




            getTypes(){
                var app = this;
                axios.get('/api/issueTypeList', app.auth)
                    .then(function (response) {
                        app.types = response.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },







        },




        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: !this.editable,
                    ghostClass: "ghost"
                };
            },
            // listString() {
            //     return JSON.stringify(this.issues, null, 2);
            // },
            // list2String() {
            //     return JSON.stringify(this.issues2, null, 2);
            // },
            // list3String() {
            //     return JSON.stringify(this.issues3, null, 2);
            // }
        },
        watch: {
            isDragging(newValue) {
                if (newValue) {
                    this.delayedDragging = true;
                    return;
                }
                this.$nextTick(() => {
                    this.delayedDragging = false;
                });

            }
        }


    }
</script>











<style>

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }



    .user-image{
        height: 30px;
        width: 30px;
        overflow: hidden;
        display:inline-block;
        text-align: right;
        float: right;
        border-radius: 100%;
        border: 2px solid #CDDC39;
        margin-left: 5px
    }


    .style-img-textarea {
        top: 18px;
        right: 25px;
    }

    @media (max-width: 767px) {

        .daynamik-bg-intro {
            padding: 0 30px;
            padding-right: 33px;
            background: #F6FAFB;

        }


    }


    .modal-content  { border: #00acc1 2px solid;
        /*-webkit-border-radius: 0px !important;*/
        /*-moz-border-radius: 0px !important;*/
        /*border-radius: 0px !important;*/
    }



</style>
